import { render, staticRenderFns } from "./EditFees.vue?vue&type=template&id=6d570a1c&scoped=true&"
import script from "./EditFees.vue?vue&type=script&lang=js&"
export * from "./EditFees.vue?vue&type=script&lang=js&"
import style0 from "./EditFees.vue?vue&type=style&index=0&id=6d570a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d570a1c",
  null
  
)

export default component.exports